<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
        <el-link href="https://www.100ec.cn/Index/wjsqdws.html" target="_blank">
           <img
              src="https://www.100ec.cn/Public/home/images/dd.gif"
            />
        </el-link>
           
        </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <div>
      <div v-loading="$store.state.loading">
        <div class="text">
          <a
            v-for="(i, index) in $store.state.text"
            :key="index"
            :href="'/detail--' + i.id + '.html'"
            target="_blank"
          >
            <div class="img">
              <el-image
                v-if="index <= 40"
                :src="require('@/assets/' + index + '.jpg')"
                lazy
              ></el-image>
              <el-image
                v-else
                :src="require('@/assets/' + (index % 40) + '.jpg')"
                lazy
              ></el-image>
            </div>
            <div class="con">
              <span v-html="i.title"></span>
              <p>{{ i.post_date.split(/T|Z/).join(" ") }}</p>
            </div>
          </a>
        </div>
      </div>

      <div v-if="$store.state.more" class="more">
        <el-button type="primary" plain @click="handleSelect3">
          查看更多</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
      return {
          activeIndex: '1',
          name: '滚动播报',
          iflist: "数字文娱",
          list: "10",
          dataNav: [
              {
                  value: '数字文娱',
                  label: '滚动播报'
              },
              {
                  value: '票务',
                  label: '演出票务'
              },
              {
                  value: '音乐',
                  label: '在线音乐'
              },
              {
                  value: '视频',
                  label: '在线视频'
              },
              {
                  value: '直播',
                  label: '网络直播'
              },
              {
                  value: '短视频',
                  label: '短视频'
              },
              {
                  value: '二次元',
                  label: '二次元'
              },
              {
                  value: '文娱',
                  label: '文娱'
              },
              {
                  value: '文化',
                  label: '文化'
              },
              {
                  value: '娱乐',
                  label: '娱乐'
              },
              {
                  value: '音频',
                  label: '音频'
              },
              {
                  value: '体育',
                  label: '数字体育'
              },
              {
                  value: '阿里影业',
                  label: '阿里影业'
              },
              {
                  value: '网易云音乐',
                  label: '网易云音乐'
              },
              {
                  value: '腾讯音乐',
                  label: '腾讯音乐'
              },
              {
                  value: '猫眼',
                  label: '猫眼'
              },
              {
                  value: '爱奇艺',
                  label: '爱奇艺'
              },
              {
                  value: '虎牙',
                  label: '虎牙'
              },
              {
                  value: '斗鱼',
                  label: '斗鱼'
              },
              {
                  value: '优酷',
                  label: '优酷'
              },
              {
                  value: '淘票票',
                  label: '淘票票'
              },
              {
                  value: '大麦网',
                  label: '大麦网'
              },
              {
                  value: '荔枝',
                  label: '荔枝'
              },
              {
                  value: '喜马拉雅',
                  label: '喜马拉雅'
              },
              {
                  value: '映客',
                  label: '映客'
              },
          ],
          params: {
              json: 0,
              filter: [
                  "【",
                  "研报",
                  "分析",
                  "（PPT）",
                  "（全文）",
              ]
          }
      }
  },
  created() {
  this.$store.commit("textparams", this.params);
  // this.$store.commit("changeKeys", this.dataNav[0].value);
  if ((this.dataNav.label = "数字文娱")) {
    this.$store.commit("changeKeys", this.list);
    this.$store.dispatch("getText2");
  } else {
    this.$store.dispatch("getText");
  }
  this.$store.state.allNav.forEach((item) => {
    item.child.forEach((j) => {
      if (this.$route.path.indexOf(j.url) != -1) {
        this.title = j.name;
        if (this.title == "首页") {
          this.title = "热点聚焦";
        }

        if (item.more != undefined) {
          this.more = item.more;
        } else if (j.more != undefined) {
          this.more = j.more;
        }
      }
    })
  });
  // handleSelect3();

},
methods: {
  handleSelect(index) {
    this.iflist =  this.dataNav[index].value
    if (this.dataNav[index].value == "数字文娱") {
      this.$store.commit("changeKeys", this.list);
      this.$store.dispatch("getText2");
    } else {
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    }
  },
  handleSelect2(value) {
    this.$store.commit("changeKeys", value);
    this.$store.dispatch("getText");
  },
  handleSelect3(){
    if (this.iflist == '数字文娱') {
      this.$store.dispatch("getText2");
    } else {
      this.$store.dispatch("getText");
    }
  },
},
}
</script>
<style scoped>
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #c423ed;
    color: #303133;
}
.title{
  position: relative;
}
.title-right{
    position: absolute;
    left: 195px;
    top: 65px;
}
.title-right img{
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right{
    position: static;
    margin: 10px 0;
}
.title-right img{
  width: 100%;
  height: 50px;
}
}
</style>